<div class="col-lg-12 adduser-container-hgt">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center pb-2 globalborder-btm-header mb-2 px-3">
        <span class="col-auto">
          <h2 class="mb-0">Freight Quotation</h2>
        </span>
        <span class="col-auto">
          <span class="cross-border" (click)="onCloseModalEvent()"
            ><i class="pi pi-times"></i
          ></span>
        </span>
      </span>

      <div class="row px-3">
        <div class="col-lg-8">
          <form [formGroup]="freightForm">
            <div class="quote-bar">
              <div class="row d-flex gap-1 mb-3">
                <div class="d-inline-flex gap-2 align-items-center col-auto">
                  <div class="frm-hd">
                    <label
                      >Quote:
                      {{
                        freightForm.value.id !== 0 ? freightForm.value.id : ""
                      }}</label
                    >
                  </div>
                </div>

                <div class="d-inline-flex gap-2 align-items-center col-lg">
                  <div class="col-auto">
                    <label>Quote Name</label
                    ><span class="madatory-field">*</span>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      pInputText
                      formControlName="name"
                      autocomplete="off"
                      [ngClass]="{
                        'error-msg':
                          freightForm.get('name')?.touched &&
                          freightForm.get('name')?.invalid,
                      }" />
                  </div>
                </div>

                <div class="d-inline-flex gap-2 align-items-center col-lg">
                  <label class="col-auto">Order</label>
                  <div class="col-11">
                    <input
                      type="text"
                      autocomplete="off"
                      pInputText
                      formControlName="salesOrderIdD365" />
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-lg-12 freight-from-box quote-bar scroll-box"
              formArrayName="freightEstimationSections">
              <ng-container
                *ngFor="let shipment of groupShipments; let i = index"
                [formGroupName]="i">
                <div
                  class="mb-3 d-flex justify-content-between align-items-center">
                  <div class="d-flex gap-2 align-items-center col-auto">
                    <span class="frm-hd2">
                      <label>Shipment {{ i + 1 }}</label>
                    </span>
                  </div>

                  <div class="d-flex gap-2 align-items-center col-4">
                    <label>Name</label>
                    <div class="col-lg">
                      <input
                        type="text"
                        autocomplete="off"
                        pInputText
                        formControlName="shipmentDescription" />
                    </div>
                  </div>

                  <div class="d-flex gap-2 align-items-center col-4">
                    <label class="frm-hd">PO</label>
                    <div class="col-lg">
                      <input
                        type="text"
                        autocomplete="off"
                        pInputText
                        formControlName="poNumber" />
                    </div>
                  </div>

                  <div class="d-flex gap-2 align-items-center">
                    <span class="frm-hd">Metric:</span>
                    <div>
                      <p-checkbox
                        formControlName="isMetricUnits"
                        (onChange)="isMetricChanged(i)"
                        [binary]="true"></p-checkbox>
                    </div>
                  </div>

                  <div class="ms-3">
                    <div class="freight-btn02">
                      <p-button
                        type="button"
                        (onClick)="clearAddress(shipment)"
                        label="Clear All Addresses"></p-button>
                    </div>
                  </div>
                </div>

                <ng-container
                  *ngFor="
                    let childShipment of getAddressesFromShipments(
                      shipment.value.shipmentReferenceId
                    );
                    let idx = index
                  ">
                  <div *ngIf="idx === 1" class="freight-from-box quote-bar">
                    <div class="row mb-2 mt-2 d-flex justify-content-between">
                      <div class="d-flex gap-2 align-items-center col-lg-1">
                        <div class="frm-hd2">
                          <label>Shipment {{ i + 1 + idx }}</label>
                        </div>
                      </div>

                      <div class="d-flex gap-2 align-items-center col-lg-6">
                        <div class="frm-hd2"><label>Name</label></div>
                        <div class="frm-inpt">
                          <input
                            type="text"
                            pInputText
                            (input)="
                              onNewShipmentDetail(
                                shipment.value.ShipmentReferenceId,
                                'ShipmentDescription',
                                $event
                              )
                            "
                            [value]="
                              childShipment.get('ShipmentDescription')?.value
                            " />
                        </div>
                      </div>

                      <div class="d-flex gap-2 align-items-center col-lg-4">
                        <div class="frm-hd"><label>PO</label></div>
                        <div class="frm-inpt">
                          <input
                            type="text"
                            pInputText
                            (input)="
                              onNewShipmentDetail(
                                shipment.value.ShipmentReferenceId,
                                'PoNumber',
                                $event
                              )
                            "
                            [value]="childShipment.get('PoNumber')?.value" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <jni-freight-addresses-form
                    [formArray]="getAddressArray(childShipment)"
                    [saleOrderId]="saleOrderId"
                    [partyNumber]="partyNumber"
                    [accountNumber]="accountNumber"
                    [countryRegionList]="countryRegionList"
                    [isShipment]="idx === 1"
                    [shipmentReferenceId]="shipment.value.shipmentReferenceId"
                    (updateResidential)="
                      addressResChange($event, childShipment)
                    "
                    (updateMetric)="metricChange($event, i)">
                  </jni-freight-addresses-form>
                </ng-container>

                <div
                  class="add-row mt-1 d-flex gap-3"
                  *ngIf="
                    getAddressesFromShipments(
                      shipment.value.shipmentReferenceId
                    ).length === 1
                  ">
                  <div>
                    <a (click)="setAddressGroupShipment(i)" href="javascript:;"
                      >+ Add Another Address</a
                    >
                  </div>
                  <div>
                    <a
                      (click)="setAddressGroupShipmentFrom(i)"
                      href="javascript:;"
                      >+ Use to address for next from</a
                    >
                  </div>
                </div>

                <div class="add-row mt-1 d-flex gap-3">
                  <div
                    *ngIf="
                      getAddressesFromShipments(
                        shipment.value.shipmentReferenceId
                      ).length === 2
                    ">
                    <a
                      href="javascript:;"
                      (click)="
                        ungroupAddressShipment(
                          shipment.value.shipmentReferenceId
                        )
                      ">
                      + Create blank pkg section for shipment {{ i + 2 }}
                    </a>
                  </div>
                  <div
                    *ngIf="
                      getAddressesFromShipments(
                        shipment.value.shipmentReferenceId
                      ).length === 2
                    ">
                    <a
                      href="javascript:;"
                      (click)="
                        ungroupAddressWithCopy(
                          shipment.value.shipmentReferenceId
                        )
                      ">
                      + Copy pkg section below to shipment {{ i + 2 }}
                    </a>
                  </div>
                </div>

                <jni-freight-packages-form
                  *ngIf="shipment"
                  [formArray]="getPackageArray(shipment)"
                  (appendPackage)="appendPackage(i)"
                  (removePackage)="removePackage(i, $event)"
                  [shipmentReferenceId]="shipment.value.shipmentReferenceId"
                  [estimations]="estimations"
                  (updatePackage)="onPackageUpdate($event)"
                  (updateWeight)="onWeightUpdate($event)"
                  [pricingResponse]="shippingResponse"
                  (removeShipment)="removeShipment(i)"
                  [currentShipment]="i">
                </jni-freight-packages-form>

                <div class="gray-bg-rounded mt-3">
                  <div
                    class="col-lg-12 d-flex freight-btm-bar p-2 gap-4 align-items-center">
                    <div class="ver-col flex-column d-flex gap-1">
                      <!-- <h2>CARRIER<span class="madatory-field">*</span></h2> -->

                      <div *ngFor="let carrier of carriers">
                        <label for="vendorRadio">
                          <p-radioButton
                            formControlName="shippingCarrier"
                            class="me-2"
                            [value]="carrier.carrier"
                            (onClick)="onChangeCarrier(carrier.carrier, i)" />
                          <span>{{ carrier.carrier }}</span>
                        </label>
                      </div>
                    </div>
                    <div>
                      <div
                        class="d-flex justify-content-between gap-1 align-items-center">
                        <label>
                          METHOD<span class="madatory-field">*</span>
                        </label>
                        <p-select
                          appendTo="body"
                          formControlName="shipmentMethodCode"
                          [options]="selectedCarrierList[i]"
                          optionLabel="serviceName"
                          (onChange)="setCarrierDescription($event, i)"
                          optionValue="serviceTypeCode"
                          placeholder="Select a Method">
                        </p-select>
                      </div>
                    </div>
                    <div
                      class="d-flex justify-content-between gap-1 align-items-center">
                      <label>
                        SHIP DATE<span class="madatory-field">*</span>
                      </label>
                      <div
                        [ngClass]="{
                          'error-msg-calendar': !shipment.value.shipDate,
                        }">
                        <p-datePicker
                          formControlName="shipDate"
                          class="ship-calender"
                          [showButtonBar]="true"
                          [appendTo]="'body'"
                          (onSelect)="shipDateChange(i)">
                        </p-datePicker>
                      </div>
                    </div>
                    <div
                      class="d-flex justify-content-between gap-1 align-items-center">
                      <label>PKG COUNT</label>
                      <label>
                        {{
                          totalPackagesSum(getPackageArray(shipment), shipment)
                        }}
                      </label>
                    </div>
                    <div
                      class="d-flex justify-content-between gap-1 align-items-center">
                      <label
                        [pTooltip]="tooltipContent"
                        tooltipPosition="bottom"
                        >TOT WT</label
                      >
                      <ng-template #tooltipContent>
                        <div [innerHtml]="tooltipHtml"></div>
                      </ng-template>
                      <label
                        [ngClass]="{
                          redText:
                            totalWeightSum(
                              getPackageArray(shipment),
                              shipment
                            ) >= 250,
                        }">
                        {{
                          totalWeightSum(getPackageArray(shipment), shipment)
                        }}
                        {{ shipment.value.isMetricUnits ? "KG" : "LB" }}
                      </label>
                    </div>
                    <div
                      class="d-flex justify-content-between gap-1 align-items-center">
                      <label>Total $:</label>
                      <label>{{ qouteTotalPrice }}</label>
                    </div>
                  </div>
                </div>
                <div class="gray-bg-rounded mt-3">
                  <div
                    *ngIf="i === groupShipments.length - 1"
                    class="col-lg-12 mt-4">
                    <h3>Accuracy of Estimates -</h3>
                    <p>
                      This tool is intended for internal use only and provides
                      estimates based on the information entered. The accuracy
                      of the estimate depends on the accuracy of the data
                      provided. We recommend including a buffer of 10% when
                      sharing quotes with clients to account for potential
                      variances.
                    </p>

                    <h3>Scope of Estimate -</h3>
                    <p>
                      The estimate generated covers transit costs only. It does
                      not include duties, taxes, or other potential charges. For
                      assistance with estimating duties and taxes, please
                      contact
                      <a href="mailto:trade@nadel.com">trade&#64;nadel.com</a>
                    </p>

                    <h3>Weight Limit Consideration -</h3>
                    <p>
                      If your total shipment weight exceeds 250 lbs., please
                      contact Freight&#64;nadel.com for an air freight quote, as
                      this tool is optimized for standard shipments under this
                      limit
                    </p>
                  </div>
                </div>
              </ng-container>
            </div>

            <div class="d-flex justify-content-end">
              <div class="freight-btn02 d-flex gap-2 justify-content-between">
                <p-button
                  type="button"
                  label="Save"
                  (onClick)="saveQuotation()">
                </p-button>
                <p-button
                  *ngIf="displayPrice"
                  type="button"
                  label="Price"
                  (onClick)="getEstimations()"></p-button>
              </div>
            </div>
          </form>
        </div>

        <div class="col-lg-4">
          <jni-freight-charges-detail
            [estimations]="estimations"
            [quoteId]="quoteId"
            (multiPricingSelection)="onSelectMultiPricing($event)"
            (emitQouteTotalPrice)="
              getQouteTotalPrice($event)
            "></jni-freight-charges-detail>
        </div>
      </div>
    </p-card>
  </div>
</div>

<jni-confirm-dialog
  [dialogMessage]="addressClearMessage"
  dialogHeading="Are you sure?"
  *ngIf="clearAlertVisible"
  [hideIcon]="true"
  (confirmDialogStatus)="confirmClearAddress($event)">
</jni-confirm-dialog>
